import { createAsyncThunk } from '@reduxjs/toolkit'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { calculateDefaultUnit } from '../../../../../../common/selectCurrencyUnit/slice'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'
import { mapAllVNDValue } from '../../../helper'

export const getSecuFinancialAssetsThunk = createAsyncThunk(
  'financialAnalysis/Secu/GET_FINANCIAL_ASSETS',
  async (data, { rejectWithValue, dispatch }) => {
    const response = await FinancialAnalysisService.getFinancialAssets(data)
    if (response.success) {
      dispatch(
        calculateDefaultUnit({
          screen: SCREEN.FINANCIAL_ANALYSIS,
          getValues: () => mapAllVNDValue(response.data),
        }),
      )
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadFinancialAssets = createAsyncThunk(
  'financialAnalysis/Secu/DOWNLOAD_FINANCIAL_ASSETS',
  async (data) => {
    const response = await FinancialAnalysisService.downloadFinancialAssets(
      data,
    )
    handleExport(response.data, response.filename)
  },
)
